export default () => [0, 1, 2].map(() => Math.floor(Math.random() * (999 - 100 + 1) + 100));
